<h2 mat-dialog-title>Leave thread?</h2>

<mat-dialog-content>
  <ng-container *ngIf="mode === 'thread'">
    If you leave this thread, you will not be able to add to or see this thread
    until someone in the thread adds you back.
  </ng-container>
  <ng-container *ngIf="mode === 'task'">
    If you leave this thread, you will not be notified of updates to this thread
    until you are added back to this thread.
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="warn" (click)="accept()">
    Leave thread
  </button>
</mat-dialog-actions>
